<agr-page [pageTitle]="pageTitle$ | async">
  <agr-form
    [formGroup]="form"
    class="layout--padding-bottom flex--gutter-container"
    style="padding-bottom: 0"
  >
    <div class="flex--row flex--gutter">
      <mat-form-field class="flex__child--auto" appearance="outline">
        <!-- Add this directive when implementing AutoComplete  [matAutocomplete]="auto"-->
        <input
          matInput
          [matAutocomplete]="auto"
          formControlName="search"
          placeholder="{{ 'search_profile' | translate }}"
          (keydown.escape)="clearSearchbox()"
          (keydown.enter)="searchProfiles()"
          (click)="searchProfiles()"
        />

        <mat-autocomplete #auto="matAutocomplete">
          <mat-option
            *ngFor="let option of options$ | async"
            [value]="option.email"
            (onSelectionChange)="searchProfiles()"
            (keydown.enter)="searchProfiles()"
            (click)="searchProfiles()"
          >
            <div>
              <b>{{ option.firstName?.toString() }}&nbsp; {{ option.lastName?.toString() }}</b>
            </div>
            <div>
              <i>{{ option.email?.toString() }}</i>
            </div>
          </mat-option>
        </mat-autocomplete>
        <button mat-button color="primary" matTextSuffix (click)="useMyEmail()" type="button">
          {{ 'use_my_email' | translate }}
        </button>
        <button mat-icon-button matSuffix (click)="clearSearchbox()" type="button">
          <mat-icon>clear</mat-icon>
        </button>
      </mat-form-field>
    </div>
  </agr-form>

  <!--User Profile-->
  <ng-container *ngIf="profile$ | async as profile">
    <mat-tab-group>
      <!--Basic Information-->
      <mat-tab label="Basic information">
        <br />
        <app-profile-basic-information
          [profile]="profile"
          [b2cProfile]="b2cProfile$ | async"
        ></app-profile-basic-information>
      </mat-tab>
      <!--Licenses-->
      <mat-tab label="Roles &amp; Licenses">
        <br />
        <app-profile-licenses
          *ngIf="applications$ | async"
          [applications]="applications$ | async"
          [applicationGroups]="applicationGroups$ | async"
        ></app-profile-licenses>
      </mat-tab>
    </mat-tab-group>
  </ng-container>
  <ng-container *ngIf="showNotFound">
    <div class="wrapper">
      <div class="row--container">
        <div class="row">
          <div class="col-5">
            <p class="landing-highlights">
              We could not find the profile you're looking for.<br />
              Perhaps because of one of the following reasons:
            </p>
            <ul class="landing-highlights">
              <li>Spelling mistake in the email address</li>
              <li>The contact person or employee does not exist</li>
              <li>The contact person or employee has not (yet) synchronized</li>
            </ul>
            <br />
          </div>
          <div class="col-3">
            <img src="assets/undraw_tabs_jf82.svg" />
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</agr-page>
